import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Nav from '../Nav'
import AppDashboard from '../UserDashBoard';
// import Users from '../Users';
// import Branch from '../Branch';
// import { setLoggedInUser } from '../../features/auth/authSlice';
// import { getUsersFromUsersTableById } from "../../api/reusableApis";
import { setActiveItem } from '../../features/nav/navSlice';
import ListBookings from '../ListBookings';
import Bookings from '../Bookings';
import Profile from '../Profile';
import Modal from "../../components/modal";
import Booking from '../Booking';
// import dayjs from 'dayjs';
import { FiLogOut } from 'react-icons/fi'; // Modern icons

function UserLayouts() {

  const activeItem = useSelector((state) => state.nav.activeItem);
  const dispatch = useDispatch();
  const currentLoggedInUser = useSelector((state) => state.auth.currentUser);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const pageContent = () => {
    // Hide content during logout modal
    if (activeItem === 'Logout') return null;

    switch (activeItem) {
      case 'Dashboard': return <AppDashboard />;
      case 'Profile': return <Profile />;
      case "Create Booking": return <Bookings />;
      case "List Bookings": return <ListBookings />;
      case "Booking Table": return <Booking />;
      default: return <AppDashboard />;
    }
  };

  useEffect(() => {
    console.log(activeItem);
    if (activeItem === 'Logout') {
      setShowLogoutModal(true);
    }
  }, [activeItem]);

  const confirmLogout = () => {
    dispatch(setActiveItem('Dashboard'));
    setShowLogoutModal(false);
    logout();
  };

  const cancelLogout = () => {
    dispatch(setActiveItem('Profile')); // or store previous item
    setShowLogoutModal(false);
  };

  function logout() {
    const redirectURL = '/__catalyst/auth/login';
    window.catalyst.auth.signOut(redirectURL);
  }



  // useEffect(() => {
  //   console.log(currentLoggedInUser, 'currentLoggedInUser');
  //   var userManagement = window.catalyst.auth;
  //   var currentUserPromise = userManagement.isUserAuthenticated();
  //   currentUserPromise.then(async (response) => {
  //     console.log(response, 'response');
  //     if (response['status'] === 200) {
  //       var data = response['content'];
  //       if (data && data['status'] === "ACTIVE" && data['role_details']['role_name'] === 'App User') {
  //         const userDetails = await getUsersFromUsersTableById(data['user_id']);
  //         console.log(userDetails, 'userDetails');
  //         if (userDetails['success']) {
  //           data['users'] = userDetails['user'];
  //         }
  //         setIsUserAuthenticated(true);
  //         dispatch(setLoggedInUser(data));
  //       } else if (data && data['status'] === "ACTIVE" && data['role_details']['role_name'] === 'App Administrator') {
  //         console.log("You don't have access to the user's page.");
  //         setIsUserAuthenticated(false);
  //       }
  //     }
  //   }).catch((err) => {
  //     console.log("Kindly login to the application.--- user")
  //     setIsUserAuthenticated(false);
  //   });
  // }, []);

  // useEffect(() => {
  //   let isMounted = true;

  //   const checkAuth = async () => {
  //     try {
  //       if (!window.catalyst?.auth) return;

  //       const response = await window.catalyst.auth.isUserAuthenticated();

  //       if (!isMounted) return;

  //       if (response.status === 200) {
  //         const data = response.content;

  //         if (
  //           data?.status === "ACTIVE" &&
  //           data?.role_details?.role_name === "App User"
  //         ) {
  //           const userDetails = await getUsersFromUsersTableById(data.user_id);

  //           if (isMounted && userDetails?.success) {
  //             data.users = userDetails.user;
  //           }

  //           setIsUserAuthenticated(true);
  //           dispatch(setLoggedInUser(data));
  //           return;
  //         }

  //         // Logged in but wrong role
  //         setIsUserAuthenticated(false);
  //         return;
  //       }

  //       setIsUserAuthenticated(false);
  //     } catch (err) {
  //       console.error("Auth failed", err);
  //       setIsUserAuthenticated(false);
  //     }
  //   };

  //   checkAuth();

  //   // ✅ proper cleanup
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [dispatch]);


  return (
    <>
      <div className="min-h-screen bg-[#F7F9FC] flex font-sans">
        <Nav />
        {pageContent()}
      </div>



      <Modal
        open={showLogoutModal}
        onClose={cancelLogout}
        title="Logout"
        width="w-[92%] max-w-[380px] overflow-hidden"
        info=""
      >
        {/* Top Brand Accent Bar */}
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#72398E]" />

        <div className="flex flex-col items-center p-4 text-center">

          {/* Animated Icon Container */}
          <div className="relative mb-6 mt-4">
            <div className="absolute inset-0 rounded-full bg-[#72398E] opacity-10 animate-ping" />
            <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-purple-50 text-[#72398E] border-2 border-white shadow-sm">
              <FiLogOut size={32} />
            </div>
          </div>

          {/* Typography */}
          <div className="space-y-2 mb-8">
            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight">
              Ready to go?
            </h3>
            <p className="text-sm text-gray-500 px-4 leading-relaxed">
              We'll save your progress. Sign back in anytime to continue creating surprises!
            </p>
          </div>

          {/* Buttons: Stacked for Mobile, Row for Desktop */}
          <div className="flex flex-col-reverse sm:flex-row w-full gap-3 px-2">
            <button
              onClick={cancelLogout}
              className="flex-1 px-6 py-3 text-sm font-bold text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-2xl transition-all duration-200"
            >
              Wait, go back
            </button>

            <button
              onClick={confirmLogout}
              className="flex-[1.5] px-6 py-3 bg-[#72398E] hover:bg-[#5a2d71] text-white text-sm font-bold rounded-2xl shadow-lg shadow-purple-200 transition-all duration-200 transform hover:-translate-y-0.5 active:scale-95 flex items-center justify-center gap-2"
            >
              Confirm Logout
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default UserLayouts